import { Box } from '@mui/material';
import { useState } from 'react';
import global_constant from '../../../assets/json/global_constant.json';
import EntityCTAButtons from './EntityCTAButtons';
import EntityTabContainor from './EntityTabContainor';
import EntityTabs from './EntityTabs';

const EntityContainer = ({ editableEntityData, setEditableEntityData, entertainment_entity_filter, artists, handleEntityCTAButtonsClick, createQuestions,getMultiMediaByEntityId,editableEntityMultimediaData }) => {

    const [tabIndex, setTabIndex] = useState(0);
    const {
        language,
        industry,
        country,
        geners_type,
        song_genres,
        movie_genres,
        multimedia_types,
        multimedia_ratio,
        artist_types,
        entertainment_entity_types,
    } = global_constant;

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Box sx={{
            flex: 1,
            height: '100%',
            display: "flex",
            padding: 0,
            flexDirection: "column",
            gap: 0,
        }}>

            <EntityTabs editableEntityData={editableEntityData} tabIndex={tabIndex} handleTabChange={handleTabChange} />

            <EntityTabContainor 
            tabIndex={tabIndex} 
            editableEntityData={editableEntityData} 
            setEditableEntityData={setEditableEntityData} 
            artists={artists} 
            global_constant={entertainment_entity_filter} 
            createQuestions={createQuestions}
            getMultiMediaByEntityId={getMultiMediaByEntityId}
            editableEntityMultimediaData={editableEntityMultimediaData}
            />

            <EntityCTAButtons editableEntityData={editableEntityData} handleEntityCTAButtonsClick={handleEntityCTAButtonsClick} />

        </Box>
    )
}

const styles = {

};

export default EntityContainer
